//src/api/interceptors/interceptor.ts
import { authRequestInterceptor, authResponseInterceptor } from '@/api/interceptors/authInterceptors';
import type { RequestInterceptor, ResponseInterceptor } from "@/types/shared/interceptor.types";

export const interceptors = {
  request: new Set<RequestInterceptor>([
    authRequestInterceptor,
  ]),
  response: new Set<ResponseInterceptor>([
    authResponseInterceptor,
  ]),
};
